module.exports = __webpack_public_path__ + "img/pageinteriors_empresas-y-corporativos-05persona-clave.2ac544f2.jpg";